const PRIVACY_POLICY_FALLBACK = `
_Last updated: August 2026_

## Information we collect

Culture Ken processes account details, profile preferences, approximate or precise location when you grant permission, purchase records, referral activity, and app diagnostics needed to provide the service.

## How we use information

We use this information to authenticate accounts, personalise recommendations, provide and synchronise audio guides, process purchases, prevent abuse, improve reliability, and meet legal obligations.

## Sharing and service providers

We share only the information needed by providers that support hosting, maps, payments, analytics, audio generation, and error monitoring. We do not sell personal information.

## Retention and your choices

Information is retained only while needed for the purposes above and applicable legal requirements. You can update profile information and permissions in the app or contact us to request access, correction, or deletion.

## Contact

For privacy questions, use the support contact provided by Culture Ken.
`;

const TERMS_OF_USE_FALLBACK = `
_Last updated: August 2026_

## Using Culture Ken

You must provide accurate account information, keep your credentials secure, and use Culture Ken only for lawful personal purposes. You are responsible for activity performed through your account.

## Credits, purchases, and subscriptions

Credits and subscriptions provide access to eligible audio guides. Mobile purchases are also subject to the App Store or Google Play terms. Except where required by law or store policy, consumed credits are not refundable.

## Content and availability

Audio guides and place information are provided for cultural and informational use. Availability, accuracy, languages, and features may change, and generated content should not be treated as professional advice.

## Acceptable use

You may not misuse the service, attempt unauthorised access, interfere with its operation, copy protected content at scale, or use Culture Ken to violate another person's rights.

## Account action and changes

We may restrict accounts that breach these terms or threaten the service. We may update these terms and will publish the current version on this page.

## Contact

For questions about these terms, use the support contact provided by Culture Ken.
`;

const markdownFromEnv = (value, fallback) => {
  const configured = String(value || '').trim();
  return (configured || fallback).replace(/\\n/g, '\n').trim();
};

export const PRIVACY_POLICY_MARKDOWN = markdownFromEnv(
  process.env.REACT_APP_PRIVACY_POLICY_MARKDOWN,
  PRIVACY_POLICY_FALLBACK,
);

export const TERMS_OF_USE_MARKDOWN = markdownFromEnv(
  process.env.REACT_APP_TERMS_OF_USE_MARKDOWN,
  TERMS_OF_USE_FALLBACK,
);

